var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"group-67","transform":"translate(0.302 0.129)"},[React.createElement("ellipse",{"id":"ellipse-12","cx":"22.5","cy":"23","rx":"22.5","ry":"23","transform":"translate(-0.302 -0.129)","key":0}),React.createElement("path",{"id":"facebook","d":"M18.373,2h0V6.549H16.1c-.785,0-1.137.921-1.137,1.706V11.1h3.412v4.549H14.961v9.1H10.412v-9.1H7V11.1h3.412V6.549A4.549,4.549,0,0,1,14.961,2Z","transform":"translate(9.917 9.693)","fill":"#fff","key":1})]));
}

Facebook.defaultProps = {"width":"45","height":"46","viewBox":"0 0 45 46"};

module.exports = Facebook;

Facebook.default = Facebook;
